// Prepared secure grading adapter. Disabled until backend and public Sanity answers are secured.
import { supabase } from "../../supabaseClient";

export const secureKnowledgeChecksEnabled =
  process.env.REACT_APP_SECURE_KC_ENABLED === "true";

export async function verifyKnowledgeCheck({
  levelKey,
  questionKey,
  curriculumGeneration,
  assessmentVersion,
  answer,
}) {
  if (!secureKnowledgeChecksEnabled) {
    throw new Error("Secure Knowledge Checks are not enabled.");
  }

  if (
    !/^L[1-9]\d*$/i.test(String(levelKey || "")) ||
    !/^KC[1-9]\d*$/.test(String(questionKey || ""))
  ) {
    throw new Error("Invalid Knowledge Check identifier.");
  }

  if (
    !curriculumGeneration ||
    !Number.isSafeInteger(Number(assessmentVersion)) ||
    Number(assessmentVersion) < 1
  ) {
    throw new Error(
      "Assessment metadata is missing. Please try again later."
    );
  }

  // The lesson ID is resolved from the existing Supabase catalogue,
  // never manufactured in the browser.
  const { data: lesson, error: lookupError } = await supabase
    .from("lessons")
    .select("id")
    .eq("level_key", String(levelKey).toUpperCase())
    .single();

  if (lookupError || !lesson?.id) {
    throw new Error(
      "This lesson is not registered for secure scoring."
    );
  }

  const { data, error } = await supabase.functions.invoke(
    "verify-knowledge-check",
    {
      body: {
        lessonId: lesson.id,
        questionKey,
        curriculumGeneration,
        assessmentVersion: Number(assessmentVersion),
        answer,
      },
    }
  );

  if (error) throw error;

  if (
    !data ||
    data.status === "unavailable" ||
    typeof data.correct !== "boolean"
  ) {
    throw new Error(
      "Assessment verification is currently unavailable."
    );
  }

  return data;
}